import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { PageLayout, PageBody, BookNowButton } from "@/components/site/PageLayout";
import { ADDONS, SERVICES } from "@/data/services";

const priceLabel = (p) => `$${p.sedan} and up`;

export default function PackagesPage() {
  return (
    <PageLayout
      eyebrow="Which wash is the best for your vehicle?"
      title="Wash"
      titleAccent="Packages"
      intro="The final price may vary depending on your location, size and condition of your vehicle. Maintenance plans available — contact us (maintenance details are only available after we've performed a full detail & inspection)."
    >
      <PageBody>
        <div className="space-y-10">
          {SERVICES.map((s) => (
            <article
              key={s.id}
              data-testid={`packages-page-${s.id}`}
              className={`bg-[#121216] border p-7 md:p-10 ${s.featured ? "border-[#EA0A0B]" : "border-[#232329]"}`}
            >
              <div className="flex flex-wrap items-baseline justify-between gap-3">
                <h2 className="font-display uppercase text-2xl md:text-3xl tracking-wide text-white">
                  {s.name}
                  {s.badge && (
                    <span className="ml-3 align-middle bg-[#EA0A0B] text-white font-display text-[11px] tracking-[0.15em] px-3 py-1">
                      {s.badge}
                    </span>
                  )}
                </h2>
                <p className="font-display text-2xl text-[#FF4311]">{priceLabel(s.prices)}</p>
              </div>
              <p className="mt-3 text-slate-300 leading-relaxed">{s.tagline}</p>
              <p className="mt-2 font-mono text-xs uppercase tracking-[0.15em] text-slate-500">
                {s.time} · {s.includes} services included
              </p>
              {s.groups ? (
                s.groups.map((g) => (
                  <div key={g.label} className="mt-6">
                    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-[#FF4311]">{g.label}</h3>
                    <ul className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2.5">
                      {g.items.map((h) => (
                        <li key={h} className="flex items-start gap-2.5 text-sm text-slate-300">
                          <Check className="w-4 h-4 mt-0.5 text-[#EA0A0B] shrink-0" />
                          {h}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              ) : (
                <ul className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2.5">
                  {s.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-2.5 text-sm text-slate-300">
                      <Check className="w-4 h-4 mt-0.5 text-[#EA0A0B] shrink-0" />
                      {h}
                    </li>
                  ))}
                </ul>
              )}
              <div className="mt-7">
                <BookNowButton to={`/book?service=${s.id}`} testid={`packages-book-${s.id}`} label="Book Now" />
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 bg-[#121216] border border-[#232329] p-7 md:p-10">
          <h2 className="font-display uppercase text-2xl tracking-wide text-white">Add-Ons</h2>
          <ul className="mt-5 space-y-2.5">
            {ADDONS.map((a) => (
              <li key={a.id} className="flex items-center justify-between gap-4 text-sm text-slate-300 border-b border-white/5 pb-2.5">
                <span>{a.name}</span>
                <span className="text-[#FF4311] font-semibold">${a.price}+</span>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-slate-500 italic">
            "For the safety of your belongings, please remove all valuable items from your vehicle
            before the detailing service begins. Brad's Mobile Detailing is not responsible for any lost
            or missing items."
          </p>
        </div>

        <div className="mt-10 text-sm text-slate-400">
          We can also detail your{" "}
          <Link to="/boat-detailing-packages" className="text-[#FF4311] hover:underline">Boat</Link>,{" "}
          <Link to="/motorcycle-detailing-packages" className="text-[#FF4311] hover:underline">Motorcycle</Link> or{" "}
          <Link to="/rv-detailing-packages" className="text-[#FF4311] hover:underline">RV</Link>.
        </div>
      </PageBody>
    </PageLayout>
  );
}
